import type { AppStatus } from "../types/platform";

export type StatusLine = "solid" | "dashed" | "dotted";

// Status is carried by line style, not color: the map is already orange on
// black. Key order is the legend order. Everything on the map is a proof of
// concept, so the top state is "Running", not "Live" (which reads as
// customer production).
export const APP_STATUS: Readonly<
  Record<AppStatus, { label: string; line: StatusLine }>
> = {
  running: { label: "Running", line: "solid" },
  demoable: { label: "Demoable", line: "dashed" },
  "in-dev": { label: "In dev", line: "dashed" },
  concept: { label: "Concept", line: "dotted" }
};
